(() => {
    if (customElements.get('bundle-picker')) return;

    class BundlePicker extends HTMLElement {
      connectedCallback() {
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
        this.items = Array.from(this.querySelectorAll('[data-bundle-item]'));
        this.button = this.querySelector('[data-bundle-add]');
        this.label = this.querySelector('[data-bundle-btn-label]');
        this.defaultLabel = this.label ? this.label.textContent : '';
        this.totalEl = this.querySelector('[data-bundle-total]');
        this.compareEl = this.querySelector('[data-bundle-compare]');
        this.saveEl = this.querySelector('[data-bundle-save]');
        this.countEl = this.querySelector('[data-bundle-count]');
        this.errorEl = this.querySelector('[data-bundle-error]');

        this.items.forEach((item) => {
          const input = item.querySelector('.dbp-bundle__check');
          if (!input) return;
          input.addEventListener('change', () => {
            item.classList.toggle('is-on', input.checked);
            item.classList.toggle('is-off', !input.checked);
            this.recalculate();
          });
        });

        this.button?.addEventListener('click', () => this.addToCart());
        this.recalculate();
      }

      selected() {
        return this.items.filter((item) => {
          const input = item.querySelector('.dbp-bundle__check');
          return input && input.checked && !input.disabled && item.dataset.available === 'true';
        });
      }

      formatMoney(cents) {
        const value = (cents / 100);
        const withDot = (n, dec) => n.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const withComma = (n, dec) => n.toFixed(dec).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d),)/g, '.');
        return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name) => {
          switch (name) {
            case 'amount': return withDot(value, 2);
            case 'amount_no_decimals': return withDot(Math.round(value), 0);
            case 'amount_with_comma_separator': return withComma(value, 2);
            case 'amount_no_decimals_with_comma_separator': return withComma(Math.round(value), 0);
            case 'amount_with_apostrophe_separator': return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
            default: return withDot(value, 2);
          }
        });
      }

      recalculate() {
        const picked = this.selected();
        let total = 0;
        let compare = 0;
        picked.forEach((item) => {
          const price = parseInt(item.dataset.price, 10) || 0;
          let cmp = parseInt(item.dataset.compare, 10) || price;
          if (cmp < price) cmp = price;
          total += price;
          compare += cmp;
        });

        if (this.totalEl) this.totalEl.textContent = this.formatMoney(total);
        if (this.countEl) this.countEl.textContent = picked.length === 1 ? '1 item selected' : `${picked.length} items selected`;

        const saving = compare - total;
        if (this.compareEl) {
          this.compareEl.textContent = saving > 0 ? this.formatMoney(compare) : '';
          this.compareEl.hidden = saving <= 0;
        }
        if (this.saveEl) {
          this.saveEl.textContent = saving > 0 ? `Save ${this.formatMoney(saving)}` : '';
          this.saveEl.classList.toggle('is-shown', saving > 0);
        }
        if (this.button) this.button.disabled = picked.length === 0;
        this.hideError();
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.classList.add('is-shown');
      }

      hideError() {
        this.errorEl?.classList.remove('is-shown');
      }

      async addToCart() {
        const picked = this.selected();
        if (!picked.length) return;

        this.hideError();
        this.button.classList.add('is-loading');
        this.button.disabled = true;
        if (this.label) this.label.textContent = 'Adding\u2026';

        const drawer = document.querySelector('cart-drawer');
        const sections = drawer ? drawer.getSectionsToRender().map((s) => s.id) : [];

        const body = {
          items: picked.map((item) => ({ id: Number(item.dataset.variantId), quantity: 1 })),
        };
        if (sections.length) {
          body.sections = sections;
          body.sections_url = window.location.pathname;
        }

        try {
          const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
          const response = await fetch(`${cartAddUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify(body),
          });
          const data = await response.json();

          if (!response.ok || data.status) {
            this.showError(data.description || data.message || 'These items could not be added to your cart.');
            return;
          }

          if (drawer && data.sections) {
            // Dawn puts `is-empty` on <cart-drawer> itself, but renderContents only
            // clears it from .drawer__inner. If the cart was empty when the page
            // loaded, the drawer opens but the CSS keeps the new items hidden.
            drawer.classList.remove('is-empty');
            drawer.renderContents(data);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }

          document.dispatchEvent(new CustomEvent('dbp:bundle:added', { detail: { items: body.items } }));
        } catch (error) {
          this.showError('Connection problem. Please try again.');
        } finally {
          this.button.classList.remove('is-loading');
          this.button.disabled = this.selected().length === 0;
          if (this.label) this.label.textContent = this.defaultLabel;
        }
      }
    }

    customElements.define('bundle-picker', BundlePicker);
  })();
